import React, { useState } from 'react';

/**
 * Popup för att fråga användaren om de vill signera PDF:en
 *
 * Props:
 *   show: boolean - visa/dölj popup
 *   hasCertificate: boolean - om certifikat finns uppladdat
 *   onSign: (password: string) => void - callback vid signering
 *   onSkip: () => void - callback för att hoppa över signering
 *   onCancel: () => void - callback för att avbryta
 *   isLoading: boolean - om signering pågår
 *   error: string|null - felmeddelande
 */
const SignPdfPopup = React.memo(({
  show,
  hasCertificate,
  onSign,
  onSkip,
  onCancel,
  isLoading,
  error
}) => {
  const [password, setPassword] = useState('');

  if (!show) return null;

  const handleSign = () => {
    if (password.trim()) {
      onSign(password);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && password.trim()) {
      handleSign();
    }
  };

  return (
    <div className="sign-pdf-popup-overlay">
      <div className="sign-pdf-popup">
        <h3>Signera PDF?</h3>

        {!hasCertificate ? (
          <>
            <p className="sign-pdf-warning">
              Inget certifikat uppladdat. Du kan ladda upp ditt .pfx-certifikat
              i inställningarna för att kunna signera PDF:er.
            </p>
            <div className="sign-pdf-popup-buttons">
              <button
                className="sign-pdf-button-secondary"
                onClick={onCancel}
              >
                Avbryt
              </button>
              <button
                className="sign-pdf-button-primary"
                onClick={onSkip}
              >
                Skapa utan signatur
              </button>
            </div>
          </>
        ) : (
          <>
            <p>Ange lösenordet för ditt certifikat för att signera PDF:en digitalt.</p>

            <div className="sign-pdf-input-group">
              <label htmlFor="cert-password">Certifikatlösenord:</label>
              <input
                id="cert-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Ange lösenord..."
                disabled={isLoading}
                autoFocus
              />
            </div>

            {error && (
              <p className="sign-pdf-error">{error}</p>
            )}

            <div className="sign-pdf-popup-buttons">
              <button
                className="sign-pdf-button-cancel"
                onClick={onCancel}
                disabled={isLoading}
              >
                Avbryt
              </button>
              <button
                className="sign-pdf-button-secondary"
                onClick={onSkip}
                disabled={isLoading}
              >
                Utan signatur
              </button>
              <button
                className="sign-pdf-button-primary"
                onClick={handleSign}
                disabled={isLoading || !password.trim()}
              >
                {isLoading ? 'Signerar...' : 'Signera'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
});

SignPdfPopup.displayName = 'SignPdfPopup';

export default SignPdfPopup;
